<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <AnalyzeRecordForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AnalyzeRecordForm from '@/components/organisms/terminal/form/AnalyzeRecordForm'

export default {
  name: 'AnalyzeRecordPage',

  components: {
    AnalyzeRecordForm,
  },
}
</script>
